import React from 'react';
import {useSelector} from 'react-redux';

import AppButton from '../../../components/Button/AppButton/AppButton';
import ConnectionTrackButton from '../../../components/Button/ConnectionTrackButton/ConnectionTrackButton';
import {ArticlePageLayout} from '../../../components/DataDisplay';
import {IconWarranty} from '../../../components/Icons';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getPreferenceCenterType} from '../../../consts/tnc/tncTypes';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import analyticsService from '../../../services/analyticsService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import appRouterService from '../../../services/route/appRouterService';
import tncService from '../../../services/tncService';
import {hideLoader, showLoader} from '../../../state/ducks/global';
import {makeSelectAcceptedTncByType, makeSelectTncByType} from '../../../state/selectors/consumer';
import {dispatch} from '../../../state/store';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import TermsOfUseDescription from '../TermsOfUseDescription/TermsOfUseDescription';

const DataCollectionPage = () => {
    const localizedStrings = getLocalizedStrings();
    const tncType = getPreferenceCenterType();
    const dataCollectionTnc = useSelector(makeSelectTncByType(tncType));
    const acceptedTermsOfUse = useSelector(makeSelectAcceptedTncByType(tncType));

    useDocumentTitle(localizedStrings[localizationKeys.DATA_COLLECTION_PAGE_TITLE]);

    if (!dataCollectionTnc) return null;

    const {description, legals, updateDescription} = dataCollectionTnc;

    if (!legals) return null;

    const setTnc = async (isAccepted) => {
        dispatch(showLoader());

        analyticsService.pushTNCDataCollectionInteractionEvent(isAccepted);
        await tncService.setDataCollectionTnc(legals, isAccepted);

        dispatch(hideLoader());
    };

    const onAcceptButtonClick = () => setTnc(true);
    const onDeclineButtonClick = () => setTnc(false);

    const isUpdatedTnc = !!acceptedTermsOfUse;
    const summaryTitleText = isUpdatedTnc
        ? localizationKeys.DATA_COLLECTION_UPDATE_TITLE
        : localizationKeys.DATA_COLLECTION_TITLE;
    const descriptionText = isUpdatedTnc ? updateDescription : description;

    return (
        <ArticlePageLayout
            containerClassName='lg:pt-16'
            icon={<IconWarranty />}
            titleClassName={'mt-4'}
            titleKey={summaryTitleText}
        >
            <TermsOfUseDescription className={'mt-8'} innerHtml={descriptionText} tncType={tncType} />
            <ConnectionTrackButton
                button={AppButton}
                primary
                light
                onClick={onAcceptButtonClick}
                testId={elementsTesIds.TNC_DC_AGREE}
            >
                {localizedStrings[localizationKeys.DATA_COLLECTION_AGREE_BUTTON]}
            </ConnectionTrackButton>
            <AppButton
                className='mt-4'
                secondary
                light
                onClick={onDeclineButtonClick}
                testId={elementsTesIds.TNC_DC_DECLINE}
            >
                {localizedStrings[localizationKeys.DATA_COLLECTION_DECLINE_BUTTON]}
            </AppButton>
            <AppButton
                className='mt-4'
                tertiary
                onClick={appRouterService.forwardToTNCPreferenceCenterPage}
                testId={elementsTesIds.TNC_DC_PREF_CENTER}
            >
                {localizedStrings[localizationKeys.DATA_COLLECTION_PREFERENCE]}
            </AppButton>
        </ArticlePageLayout>
    );
};

export default DataCollectionPage;
